export default function() {
    $(function formMod() {
        let inputContain = $('.gf_readonly');
        let inputMod = inputContain.find( 'input' );

        inputMod.prop('readonly', true);
    });
}